import { useComments } from "../presenter/useComments";
import {
  Box,
  Button,
  CircularProgress,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import { tokens } from "../../../locales/tokens";
import { CommentCard } from "./components/commentCard";
import { EmptyPage } from "../../../modules/content/category/categoryEmpty/ui";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export interface CommentsProps {
  type: "document" | "advert";
}

const DATA = {
  document: {
    title: tokens.comments.documentTitle,
  },
  advert: {
    title: tokens.comments.advertTitle,
  },
};

export const Comments = ({ type }: CommentsProps) => {
  const {
    t,
    page,
    handlePageChange,
    pageAmount,
    handleViewAll,
    handleView,
    handleReply,
    handleDelete,
    comments,
    isLoading,
    isActionLoading,
  } = useComments({ type });
  const currentData = DATA[type];

  if (!isLoading && comments.length === 0) {
    return (
      <EmptyPage
        title={t(tokens.comments.emptyTitle)}
        description={t(tokens.comments.emptyDescr)}
      />
    );
  }

  return (
    <Stack mt={2}>
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        width="100%"
        gap={2}
        marginBottom={6}
        flexWrap="wrap"
      >
        <Typography variant="h4" fontWeight={600}>
          {t(currentData.title)}
        </Typography>
        <Button
          startIcon={<VisibilityOutlinedIcon />}
          variant="contained"
          style={{
            textTransform: "none",
            marginLeft: "auto",
          }}
          onClick={handleViewAll}
        >
          {t(tokens.comments.viewAll)}
        </Button>
      </Stack>

      {isLoading ? (
        <Stack mt={3} alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <Stack>
          {comments?.length > 0 &&
            comments?.map((item) => (
              <CommentCard
                key={item.id}
                onView={handleView}
                onReply={handleReply}
                onDelete={handleDelete}
                {...item}
              />
            ))}
        </Stack>
      )}

      {/* {isActionLoading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bgcolor="rgba(0, 0, 0, 0.5)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={1300}
        >
          <CircularProgress size={60} />
        </Box>
      )} */}

      <Stack
        marginTop={4}
        marginBottom={4}
        direction="row"
        justifyContent="center"
      >
        <Pagination
          page={page}
          count={pageAmount || 1}
          onChange={handlePageChange}
          color="primary"
        />
      </Stack>
    </Stack>
  );
};
